// extracted by mini-css-extract-plugin
export default {"header":"Headers_header__ESh8G","main-image":"Headers_main-image__zfBDY"};